import { IComponentOptions, IController, IFormController, ITimeoutService } from 'angular';
import { AuthService, ILoginData } from '../../../../core/services/auth/auth.service';
import { StateService } from '@uirouter/angularjs';
import './login.component.scss';

class LoginController implements IController {
  static $inject = [
    '$state',
    '$timeout',
    'AuthService'
  ];
  data: ILoginData = {};
  stayLoggedIn = false;
  form: IFormController;
  serverError: string;
  isLoginFormActive = true;
  isResendFormActive = false;
  isConfirmResended = false;
  loading = false;

  constructor( private $state: StateService,
               private $timeout: ITimeoutService,
               private authService: AuthService ) {
  }

  $onInit() {
  }

  submit() {
    this.serverError = '';
    if ( this.form.$invalid ) {
      return;
    }
    this.loading = true;
    this.authService.login(this.data, !this.stayLoggedIn)
      .then(( data ) => {
        console.log(data);
        this.$state.go('app.dashboard.profile');
      })
      .catch(( err ) => {
        console.log(err);
        if ( err.data && err.data.text ) {
          if ( err.data.text === 'User not activated' ) {
            this.showResendForm();
            return;
          }
          return this.serverError = err.data.text;
        }
        this.serverError = 'Error';
      })
      .finally(() => this.loading = false);
  }

  resendActivation(email) {
    console.log(this.data.username);
    this.authService.sendActivationLinkEmail(email)
      .then((data) => {
        console.log(data, ' from login ctrl');
      });
    this.$timeout(() => {
      this.showResendedMessage();
    }, 1500);
  }

  private showResendForm() {
    this.isConfirmResended = false;
    this.isLoginFormActive = false;
    this.isResendFormActive = true;
  }

  private showResendedMessage() {
    this.isLoginFormActive = false;
    this.isResendFormActive = false;
    this.isConfirmResended = true;
  }

}

export const LoginComponent: IComponentOptions = {
  controller: LoginController,
  template: require('./login.component.html')
};



// WEBPACK FOOTER //
// ./app/states/auth/components/login/login.component.ts